import React from "react";
import { useExperiment } from "@growthbook/growthbook-react";
import { applicationStarted, applyNowButtonClicked } from "../utils/segment";
import Button from "./Button";
import { useLocation } from "react-router";

interface Props {
  className: string;
  siteDivName: string;
  applicationRef: any;
  location: any;
}

const CLEVER_CARE_FOUNTAIN_URL =
  "https://www.fountain.com/papa-technologies/apply/papa-pal-usa/?utm_source=FACEBOOK&utm_campaign=FB_ACQ_IPV-language";
const FACEBOOK_INBOUND =
  "https://www.fountain.com/papa-technologies/apply/papa-pal-emerging-markets?utm_source=FACEBOOK&utm_campaign=Inbound";
const GOOGLE_INBOUND =
  "https://www.fountain.com/papa-technologies/apply/papa-pal-emerging-markets?utm_source=GOOGLE&utm_campaign=Inbound";

export const ApplyNowButton = (props: Props) => {
  const query = new URLSearchParams(useLocation()?.search);
  const utmSource = query.get("utm_source")?.toLowerCase();
  const utmCampaign = query.get("utm_campaign")?.toLowerCase();
  const IS_CLEVER_CARE_CAMPAIGN = utmCampaign === "FB_ACQ_IPV-language";

  function handleClick({ applicationRef }: { applicationRef: any }) {
    applyNowButtonClicked({ siteDivName: props.siteDivName });
    if (IS_CLEVER_CARE_CAMPAIGN) {
      redirect(CLEVER_CARE_FOUNTAIN_URL);
    } else if (utmCampaign === "inbound") {
      handleInboundCampaign(applicationRef);
    } else if (utmCampaign === "summer-pal-program") {
      const redirectUrl = `https://www.fountain.com/papa-technologies/apply/papa-pal-sspp?utm_source=${utmSource?.toUpperCase()}&utm_campaign=summer-pal-program`;
      redirect(redirectUrl);
    } else {
      window.scrollTo(0, applicationRef?.current?.offsetTop - 99);
    }
  }

  function handleInboundCampaign(applicationRef: any) {
    switch (utmSource) {
      case "facebook":
        redirect(FACEBOOK_INBOUND);
        break;

      case "google":
        redirect(GOOGLE_INBOUND);
        break;

      default:
        window.scrollTo(0, applicationRef?.current?.offsetTop - 99);
        break;
    }
  }

  function redirect(redirectUrl: string) {
    applicationStarted({ state: true });
    window.location.href = redirectUrl;
  }

  /* Experiment Variation */
  const controlButton = (props: Props) => (
    <Button onClick={() => handleClick(props)}>Apply now</Button>
  );

  const variationOneButton = (props: Props) => (
    <Button onClick={() => handleClick(props)}>Apply now</Button>
  );

  /* Determines which Experiment Value to Render */
  const { value } = useExperiment({
    key: "improve-apply-now-conversion",
    variations: [controlButton(props), variationOneButton(props)],
    status: "running",
  });

  /* Apply Now Button Variation */
  return value;
};
